/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Напишіть щось',
	'About Jodit': 'Про Jodit',
	'Jodit Editor': 'Редактор Jodit',
	"Jodit User's Guide": 'Jodit інструкція користувача',
	'contains detailed help for using':
		'містить детальну інформацію щодо користування',
	'For information about the license, please go to our website:':
		'Щоб дізнатись більше про ліцензію , будь ласка, перейдіть на наш сайт:',
	'Buy full version': 'Купити повну версію',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Авторські права © XDSoft.net - Чупурнов Валерій. Всі права захищені.',
	Anchor: 'Анкор',
	'Open in new tab': 'Відкрити у новій вкладці',
	'Open in fullsize': 'Відкрити редактор в повному розмірі',
	'Clear Formatting': 'Очистити форматування',
	'Fill color or set the text color': 'Колір заливки або колір текста',
	Redo: 'Повторити',
	Undo: 'Відмінити',
	Bold: 'Жирний',
	Italic: 'Курсів',
	'Insert Unordered List': 'Вставити невпорядкований список',
	'Insert Ordered List': 'Вставити нумерованний список',
	'Align Center': 'Вирівняти по центру',
	'Align Justify': 'Вирівняти по ширині',
	'Align Left': 'Вирівняти по лівому краю',
	'Align Right': 'Вирівняти по правому краю',
	'Insert Horizontal Line': 'Вставити горизонтальну лінію',
	'Insert Image': 'Вставити зображення',
	'Insert file': 'Вставити файл',
	'Insert youtube/vimeo video': 'Вставити відео',
	'Insert link': 'Вставити посилання',
	'Font size': 'Розмір шрифту',
	'Font family': 'Шрифт',
	'Insert format block': 'Вставити блочний елемент',
	Normal: 'Нормальний текст',
	'Heading 1': 'Заголовок 1',
	'Heading 2': 'Заголовок 2',
	'Heading 3': 'Заголовок 3',
	'Heading 4': 'Заголовок 4',
	Quote: 'Цитата',
	Code: 'Код',
	Insert: 'Вставити',
	'Insert table': 'Вставити таблицю',
	'Decrease Indent': 'Збільшити відступ',
	'Increase Indent': 'Зменшити відступ',
	'Select Special Character': 'Оберіть спеціальный символ',
	'Insert Special Character': 'Вставити спеціальный символ',
	'Paint format': 'Формат краски',
	'Change mode': 'Джерело',
	Margins: 'Відступи',
	top: 'зверху',
	right: 'справа',
	bottom: 'знизу',
	left: 'зліва',
	Styles: 'Стилі',
	Classes: 'Класи',
	Align: 'Вирівнювання',
	Right: 'По правому краю',
	Center: 'По центру',
	Left: 'По лівому краю',
	'--Not Set--': '--не встановлено--',
	Src: 'src',
	Title: 'Заголовок',
	Alternative: 'Альтернативний текст (alt)',
	Link: 'Посилання',
	'Open link in new tab': 'Відкрити посилання в новій вкладці',
	file: 'Файл',
	Advanced: 'Розширені',
	'Image properties': 'Властивості зображення',
	Cancel: 'Відміна',
	Ok: 'Ок',
	'Your code is similar to HTML. Keep as HTML?':
		'Текст, який Ви намагаєтесь вставити схожий на HTML. Вставити його як HTML?',
	'Paste as HTML': 'Вставити його як HTML',
	Keep: 'Зберегти оригінал',
	Clean: 'Почистити',
	'Insert as Text': 'Вставити як текст',
	'Insert only Text': 'Вставити тільки текст',
	'Word Paste Detected': 'Можливо це фрагмент Word або Excel',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Ви вставляєте контент з документа Microsoft Word або Excel. Бажаєте зберегти форматування?',
	'File Browser': 'Браузер файлів',
	'Error on load list': 'Помилка при завантаженні списку зображень',
	'Error on load folders': 'Помилка при завантаженні списку папок',
	'Are you sure?': 'Ви впевнені?',
	'Enter Directory name': 'Введіть назву папки',
	'Create directory': 'Створити папку',
	'type name': 'введіть назву',
	'Drop image': 'Перетягніть зображення сюди',
	'Drop file': 'Перетягніть файл сюди',
	'or click': 'або клікніть',
	'Alternative text': 'Альтернативный текст',
	Browse: 'Сервер',
	Upload: 'Завантаження',
	Background: 'Фон',
	Text: 'Текст',
	Top: ' Вгору',
	Middle: 'По центру',
	Bottom: 'Донизу',
	'Insert column before': 'Вставити стовпець до',
	'Insert column after': 'Вставити стовпець після',
	'Insert row above': 'Вставити рядок вище',
	'Insert row below': 'Вставити рядок нижче',
	'Delete table': 'Видалити таблицю',
	'Delete row': 'Видалити рядок',
	'Delete column': 'Видалити стовпчик',
	'Empty cell': 'Очистити кліинку',
	source: 'HTML',
	bold: 'жирний',
	italic: 'курсів',
	brush: 'заливка',
	link: 'посилання',
	undo: 'відмінити',
	redo: 'повторити',
	table: 'таблиця',
	image: 'зображення',
	eraser: 'видалення',
	paragraph: 'параграф',
	fontsize: 'розмір шрифту',
	video: 'відео',
	font: 'шрифт',
	about: 'про редактор',
	print: 'друк',
	underline: 'підкреслений',
	strikethrough: 'закреслений',
	indent: 'відступ',
	outdent: 'заступ',
	fullsize: 'на весь екран',
	shrink: 'звичайний розмір',
	hr: 'лінія',
	ul: 'Список',
	ol: 'Нумерований список',
	cut: 'Вирізати',
	selectall: 'Виділити все',
	'Embed code': 'Код',
	'Open link': 'Відкрити посилання',
	'Edit link': 'Редагувати посилання',
	'No follow': 'Атрибут nofollow',
	Unlink: 'Видалити посилання',
	Eye: 'Перегляд',
	pencil: 'Редагування',
	Update: 'Оновити',
	' URL': 'URL',
	Edit: 'Редагувати',
	'Horizontal align': 'Горизонтальне вирівнювання',
	Filter: 'Фільтр',
	'Sort by changed': 'Сортувати за зміною',
	'Sort by name': "Сортувати за ім'ям",
	'Sort by size': 'Сортувати за розміром',
	'Add folder': 'Додати папку',
	Reset: 'Відновити',
	Save: 'Зберегти',
	'Save as ...': 'Зберегти як',
	Resize: 'Змінити розмір',
	Crop: 'Обрізати розмір',
	Width: 'Ширина',
	Height: 'Висота',
	'Keep Aspect Ratio': 'Зберегти пропорції',
	Yes: 'Так',
	No: 'Ні',
	Remove: 'Видалити',
	Select: 'Вибрати',
	'Chars: %d': 'Символів: %d',
	'Words: %d': 'Слів: %d',
	All: 'Вибрати все',
	'Select %s': 'Вибрати: %s',
	'Select all': 'Вибрати все',
	'Vertical align': 'Вертикальне вирівнювання',
	Split: 'Розділити',
	'Split vertical': 'Розділити по вертикалі',
	'Split horizontal': 'Розділити по горизонталі',
	Merge: "Об'єднати в одну",
	'Add column': 'Додати стовпчик',
	'Add row': 'Додати рядок',
	Delete: 'Видалити',
	Border: 'Рамка',
	'License: %s': 'Ліцензія: %s',
	'Strike through': 'Закреслений',
	Underline: 'Підкреслений',
	superscript: 'верхній індекс',
	subscript: 'індекс',
	'Cut selection': 'Обрізати вибране',
	Break: 'Межа',
	'Search for': 'Шукати',
	'Replace with': 'Замінити на',
	Replace: 'Замінити',
	Paste: 'Вставити',
	'Choose Content to Paste': 'Обрати контент для вставки',
	'You can only edit your own images. Download this image on the host?':
		'Ви можете редагувати лише власні зображення. Завантажити зображення на ваш сервер?',
	'The image has been successfully uploaded to the host!':
		'Зображення успішно завантажено на сервер!',
	palette: 'палітра',
	'There are no files': 'Файли відсутні',
	Rename: 'Змінити назву',
	'Enter new name': "Введіть нове імя'",
	preview: 'Попередній перегляд',
	download: 'Завантажити',
	'Paste from clipboard': 'Вставити з буфера обміну',
	"Your browser doesn't support direct access to the clipboard.":
		'Ваш браузер не підтримує доступ до буфера обміну.',
	'Copy selection': 'Копіювати виділене',
	copy: 'копія',
	'Border radius': 'Радіус рамки',
	'Show all': 'Показати все',
	Apply: 'Застосувати',
	'Please fill out this field': 'Будь ласка, заповніть це поле',
	'Please enter a web address': 'Будь ласка, введіть веб-адресу',
	Default: 'За замовченням',
	Circle: 'Коло',
	Dot: 'Крапка',
	Quadrate: 'Квадрат',
	Find: 'Знайти',
	'Find Previous': 'Знайти попередні',
	'Find Next': 'Знайти наступні',
	'Insert className': 'Вставити клас',
	'Press Alt for custom resizing': 'Натисніть Alt для зміни розміру'
};
